<template>
  <div class="wbobyy">
    <div id="wrapper">
        <div class="input-data">
            <input type="text" v-model="Noitem" @keyup.enter="UserDataSelect(Noitem)" required>
            <div class="underline">
              <i class="el-icon-circle-close" v-show="Noitem.length > 0" style="position: absolute;top: -30px;right: 60px;color:#9fa1a7;" @click="Noitem = ''"></i>
              <el-button type="primary" style="position: absolute;top: -35px;right: 1px;" size="mini" icon="el-icon-search" @click="UserDataSelect(Noitem)"></el-button>
            </div>
            <label>{{ $t('All.请扫描PASS单') }}</label>
            <i class="icon iconfont icon-saomiao saoma" style="position: absolute;top: 8px;right: 1px;color: #808080;" @click="this.Qecodefun"></i>
        </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  data () {
    return {
      Noitem: ''
    }
  },
  props: ['Addtab', 'RemoveTab', 'Renewtargename', 'Rendw'],
  created () {
  },
  mounted () {

  },
  methods: {
    ...mapMutations(['Qcrode', 'TabComponentFun']),
    async UserDataSelect (row) {
      const listdata = row.split('/')
      if (listdata.length === 6) {
        if (listdata[4] === 'CT') {
          this.IssueMaterial(listdata[5], 3)
          return
        }
        if (listdata[4] === 'CY') {
          this.IssueMaterial(listdata[5], 5)
          return
        }
        if (listdata[4] === 'ER') {
          this.IssueMaterial(listdata[5], 2)
          return
        }
        if (listdata[4] === 'ZL') {
          this.IssueMaterial(listdata[5], 4)
          return
        }
        if (listdata[4] === 'SelPrint') {
          this.IssueMaterial(listdata[5], 1)
          return
        }
        if (listdata[4] === 'Pass') {
          this.IssueMaterial(listdata[5], 0)
          return
        }
      }
      if (row.length === 29) {
        this.IssueMaterial(row, 0)
        return
      }
      if (row.length === 31) {
        var strrow = row.slice(2, 4)
        if (strrow === 'CT') {
          this.IssueMaterial(row, 3)
        } else if (strrow === 'CY') {
          this.IssueMaterial(row, 5)
        } else if (strrow === 'ER') {
          this.IssueMaterial(row, 2)
        } else if (strrow === 'ZL') {
          this.IssueMaterial(row, 4)
        } else if (strrow === 'XL') {
          this.IssueMaterial(row, 1)
        } else {
          this.IssueMaterial(row, 0)
        }
        return
      }
      const strArr = row.split('#')
      if (strArr.length === 11) {
        this.IssueMaterial(strArr[9], 0)
      } else {
        alert(this.$t('All.二维码数据异常'))
      }
    },
    async IssueMaterial (serialCode, type) {
      const loadingInstance = this.$loading({ text: this.$t('All.发料中') + '...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
      const { data: res } = await this.$http.post(`/api/MaterialLabel/IssueMaterial?serialCode=${serialCode}&type=${type}`)
      if (res.status !== 200) {
        loadingInstance.close()
        if (res.status === 209) {
          this.$confirm(`${res.msg} 需要重置标识卡状态吗?`, '提示', {
            cancelButtonText: '确认',
            confirmButtonText: '取消',
            type: 'warning'
          }).then(() => {
          }).catch(async () => {
            await this.ResetMaterial(serialCode, type)
          })
          this.Noitem = ''
          return
        }
        this.$alert(res.msg, '先进先出警告', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        this.Noitem = ''
        return
      }
      loadingInstance.close()
      this.$message.success(res.msg)
      this.Noitem = ''
    },
    async ResetMaterial (serialCode, type) {
      const loadingInstance = this.$loading({ text: this.$t('All.重置中') + '...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
      const { data: res } = await this.$http.post(`/api/MaterialLabel/ResetMaterial?serialCode=${serialCode}&type=${type}`)
      if (res.status !== 200) {
        loadingInstance.close()
        this.$message.error(res.msg)
        this.Noitem = ''
        return
      }
      loadingInstance.close()
      this.$message.success(res.msg)
      this.Noitem = ''
    },
    Qecodefun () {
      this.TabComponentFun('Qrcodesfl')
      if (typeof this.Addtab === 'function') {
        this.Addtab(this.$t('All.相机扫码发料'), 'Qrcodesfl')
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .wbobyy{
  position:absolute;
  left:0;
  right:0;
  top:0;
  bottom:0;
  margin:auto;
  height: 0px;
  width: 300px;
}
</style>
